import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PouleTable from "./PouleTable";
import BracketContainer from "../../containers/structure/BracketContainer";

export default class PouleResultsDialog extends React.Component {
  state = {
    anchorEl: null,
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  getBracketElement = (bracket) => {
    const division = this.props.divisionsObject[bracket.division];
    return (
      <div key={bracket.id} style={{ marginTop: 15 }}>
        <BracketContainer
          tournament={this.props.tournament}
          divisionsObject={this.props.divisionsObject}
          division={division}
          bracket={bracket}
          handleClickPouleSpot={this.handleClickPouleSpot}
          resultSpotsAll={this.props.resultSpotsAll}
          fase={this.props.fase}
          faseStarted={this.props.faseStarted}
          poules={this.props.poules
            .filter((poule) => poule.bracket === bracket.id)
            .sort((a, b) => a.num - b.num)}
          poulesByKey={this.props.poulesByKey}
          toggleResultSpotType={this.toggleResultSpotType}
          allPoules={this.props.poules}
          allBrackets={this.props.brackets}
          bracketsByKey={this.props.bracketsByKey}
          subBrackets={(this.props.subBrackets[bracket.id] || [])
            .sort((a, b) => a.num - b.num)
            .map((bracket) => this.getBracketElement(bracket))}
          subBracketsArray={this.props.subBrackets[bracket.id] || []}
          tournamentStatus={this.props.tournamentStatus}
          toggleFinishedDialog={this.props.toggleFinishedDialog}
          resultsPage={true}
        />
      </div>
    );
  };

  render() {
    let selectedPoule = this.props.selectedPoule;

    let poule = this.props.poulesByKey[this.props.selectedPoule] || {};
    let bracket = null;
    if (poule.bracket) {
      bracket = this.props.bracketsByKey[poule.bracket];
      selectedPoule = poule.bracket;
      while (bracket.subBracketTo) {
        selectedPoule = bracket.subBracketTo;
        bracket = this.props.bracketsByKey[bracket.subBracketTo];
      }
    }
    if (this.props.poulesByKey[this.props.selectedPoule] === undefined) {
      bracket = this.props.bracketsByKey[this.props.selectedPoule];
    }

    let poules = this.props.poules.filter((p) => !p.bracket);
    let brackets = this.props.brackets.filter((b) => !b.subBracketTo);
    let menuItems = poules.concat(brackets).sort((a, b) => {
      if (a.division < b.division) {
        return -1;
      } else if (a.division > b.division) {
        return 1;
      } else if (a.fase < b.fase) {
        return -1;
      } else if (a.fase > b.fase) {
        return 1;
      } else if (a.indexNum < b.indexNum) {
        return -1;
      } else if (a.indexNum > b.indexNum) {
        return 1;
      } else if (a.num < b.num) {
        return -1;
      } else if (a.num > b.num) {
        return 1;
      } else {
        return 0;
      }
    });
    return (
      <Dialog
        open={this.props.selectedPoule !== null}
        onClose={() => {
          this.props.selectPoule(null);
        }}
        aria-labelledby="form-dialog-title"
        maxWidth={"md"}
      >
        <DialogTitle id="form-dialog-title">
          {languages.results.seeGroupResults}
        </DialogTitle>

        <DialogContent style={{ width: 750, maxWidth: "97%", paddingTop: 0 }}>
          <Button
            size="small"
            variant="outlined"
            color="default"
            onClick={this.handleMenu}
            style={{ marginRight: 10 }}
          >
            {((bracket ? bracket.name : poule.name) || "") +
              (Object.keys(this.props.divisionsObject).length > 1
                ? " - " +
                  ((
                    this.props.divisionsObject[
                      (bracket ? bracket : poule).division
                    ] || {}
                  ).name || "")
                : "")}
          </Button>
          <Menu
            id="menu-days"
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            getContentAnchorEl={null}
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleClose}
          >
            {menuItems.map((p) => (
              <MenuItem
                key={p.id}
                selected={selectedPoule === p.id}
                onClick={(e) => {
                  this.handleClose();
                  this.props.selectPoule(p.id);
                }}
                style={{ paddingRight: 50 }}
              >
                {p.name +
                  (Object.keys(this.props.divisionsObject).length > 1
                    ? " - " +
                      ((this.props.divisionsObject[p.division] || {}).name ||
                        "")
                    : "")}
              </MenuItem>
            ))}
          </Menu>
          {bracket ? (
            this.getBracketElement(bracket)
          ) : (
            <PouleTable
              tournament={this.props.tournament}
              selectedPoule={this.props.selectedPoule}
              poulesByKey={this.props.poulesByKey}
              matches={this.props.matches}
              teams={this.props.teams}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              this.props.selectPoule(null);
            }}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.export.close}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
